import { useState } from "react";
import { Menu, X } from "lucide-react";

/**
 * Reusable demo top-nav with a mobile hamburger menu.
 * Props: logo (JSX), items (string[]), cta {label}, theme { bg, text, accent, accentText, border }.
 */
export default function DemoTopNav({ logo, items = [], ctaLabel = "Contact", onCta, theme, sticky = true, testid = "demo-nav" }) {
  const [open, setOpen] = useState(false);
  const { bg, text, accent, accentText, border } = theme;

  return (
    <nav data-testid={testid} className={`${sticky ? "sticky top-0" : ""} z-50 backdrop-blur-md border-b`} style={{ background: bg, borderColor: border }}>
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {logo}
        <div className="hidden md:flex items-center gap-8 text-xs tracking-[0.15em] uppercase" style={{ color: text, opacity: 0.85 }}>
          {items.map((i) => <span key={i} className="cursor-pointer hover:opacity-100 transition-opacity">{i}</span>)}
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onCta} data-testid="demo-nav-cta" className="hidden sm:inline-flex text-xs tracking-[0.15em] uppercase px-5 py-2.5 rounded-full font-semibold" style={{ background: accent, color: accentText }}>{ctaLabel}</button>
          <button data-testid="demo-nav-hamburger" onClick={() => setOpen((o) => !o)} className="md:hidden grid h-10 w-10 place-items-center rounded-lg" style={{ color: text }} aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="demo-nav-mobile-menu" className="md:hidden border-t px-6 py-4 space-y-3" style={{ background: bg, borderColor: border }}>
          {items.map((i) => <div key={i} className="text-sm tracking-wide uppercase" style={{ color: text }}>{i}</div>)}
          <button onClick={onCta} className="w-full text-xs tracking-[0.15em] uppercase px-5 py-3 rounded-full font-semibold" style={{ background: accent, color: accentText }}>{ctaLabel}</button>
        </div>
      )}
    </nav>
  );
}
